export const ACCURACY_SAMPLE_COUNT = 50;

export function calculatePrecisionPercentages(
  precisionPercentages: number[],
  windowHeight: number,
  x50: number[],
  y50: number[],
  staringPointX: number,
  staringPointY: number
): void {
  for (let x = 0; x < ACCURACY_SAMPLE_COUNT; x++) {
    const xDiff = staringPointX - x50[x];
    const yDiff = staringPointY - y50[x];
    const distance = Math.sqrt(xDiff * xDiff + yDiff * yDiff);
    const halfWindowHeight = windowHeight / 2;
    let precision = 0;
    if (distance <= halfWindowHeight && distance > -1) {
      precision = 100 - (distance / halfWindowHeight) * 100;
    } else if (distance > halfWindowHeight) {
      precision = 0;
    } else if (distance > -1) {
      precision = 100;
    }
    precisionPercentages[x] = precision;
  }
}

export function calculateAverage(precisionPercentages: number[]): number {
  let precision = 0;
  for (let x = 0; x < ACCURACY_SAMPLE_COUNT; x++) {
    precision += precisionPercentages[x];
  }
  return precision / ACCURACY_SAMPLE_COUNT;
}

export function calculatePrecision(
  past50Array: [number[], number[]],
  windowWidth: number,
  windowHeight: number
): number {
  const x50 = past50Array[0];
  const y50 = past50Array[1];
  const staringPointX = windowWidth / 2;
  const staringPointY = windowHeight / 2;
  const precisionPercentages = new Array(ACCURACY_SAMPLE_COUNT);
  calculatePrecisionPercentages(
    precisionPercentages,
    windowHeight,
    x50,
    y50,
    staringPointX,
    staringPointY
  );
  return Math.round(calculateAverage(precisionPercentages));
}

export function precisionFromStoredPoints(
  past50: [number[], number[]] | null | undefined,
  windowWidth: number,
  windowHeight: number
): number {
  if (!past50?.[0] || !past50?.[1]) return 0;
  const x50 = past50[0];
  const y50 = past50[1];
  // WebGazer uses `new Array(50)` — length is 50 even when empty; undefined slots
  // score as 0% in the official average. Require at least one finite sample.
  let valid = 0;
  for (let i = 0; i < ACCURACY_SAMPLE_COUNT; i++) {
    if (Number.isFinite(x50[i]) && Number.isFinite(y50[i])) valid += 1;
  }
  if (valid === 0) return 0;
  return calculatePrecision(past50, windowWidth, windowHeight);
}
